/**
 * 图形枚举
 * @author zhenliang.sun
 */
const GraphType = {
  /** 自由画笔 */
  PEN: 1,
  /** 荧光笔 */
  NITE_WHITE_PEN: 2,
  /** 方块 */
  SQUARE: 3,
  /** 圆形 */
  CIRCLE: 4,
  /** 箭头 */
  ARROW: 5,
  /** 文本 */
  TEXT: 6,
  /** 图片 */
  BITMAP: 7,
  /** 等腰三角形 */
  ISOSCELES_TRIANGLE: 8,
  /** 直角三角形 */
  RIGHT_TRIANGLE: 9,
  /** 直线 */
  LINE: 10,
  /** 单箭头 */
  SINGLE_ARROW: 11,
  /** 双箭头 */
  DOUBLE_ARROW: 12
};

const GraphName = {
  /** 自由画笔 */
  PEN: 'Path',
  /** 荧光笔 */
  NITE_WHITE_PEN: 'Path',
  /** 方块 */
  SQUARE: 'Rect',
  /** 圆形 */
  CIRCLE: 'Ellipse',
  /** 箭头 先用线代替 */
  ARROW: 'Line',
  /** 文本 */
  TEXT: 'IText',
  /** 图片 */
  BITMAP: 'Image',
  /** 三角形 */
  TRIANGLE: 'Triangle',
  /** 直角三角形 */
  RIGHT_TRIANGLE: 'Path',
  /** 直线 */
  LINE: 'Line',
  /** 单箭头 */
  SINGLE_ARROW: 'Path',
  /** 双箭头 */
  DOUBLE_ARROW: 'Path'
};

const CanvasEventType = {
  Add: 'object:added',
  Remove: 'object:removed',
  Modified: 'object:modified',
  Selected: 'selection:created',
  Deselected: 'selection:cleared',
  SelectChanged: 'selection:updated',
  MouseMove: 'mouse:move',
  MouseDown: 'mouse:down',
  MouseUp: 'mouse:up',
  MouseWheel: 'mouse:wheel',
  TextChanged: 'text:changed',
  TouchGesture: 'touch:gesture',
  TouchDrag: 'touch:drag',
  TouchOrientation: 'touch:orientation',
  TouchShake: 'touch:shake',
  TouchLongPress: 'touch:longpress',
  Drag: 'drag',
  DragOver: 'dragover',
  DragEnter: 'dragenter',
  DragLeave: 'dragleave'
};

const MessageType = {
  Add: '*add',
  Remove: '*remove',
  RemoveAll: '*remove_all',
  Modify: '*modify',
  Selected: '*selected',
  Deselected: '*deselected',
  SelectChanged: '*select_changed',
  Undo: '*undo',
  Redo: '*redo'
};

const CommandType = {
  Null: 1,
  /** 橡皮擦 */
  Eraser: 2,
  /** Undo */
  Undo: 3,
  /** Redo */
  Redo: 4,
  /** Remove all */
  RemoveAll: 5,
  /** Zoom */
  Zoom: 6
};

module.exports = {
  GraphType,
  GraphName,
  CanvasEventType,
  MessageType,
  CommandType
};
